<template>
  <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex">
    <a
      :href="model.publicUrl"
      @click.prevent="openPublicUrl(model.publicUrl)"
      class="tw-relative card model-car model-card mb-4 h-auto cursor-pointer"
    >
      <div class="tw-absolute">
        <span class=" tw-top-2 tw-left-2 badge badge-danger badge-sm text-uppercase" v-if="model.stock_number > 0">Készleten</span>
        <month-badge v-else  :date="model.take_over_month" />
      </div>
      <img
        :src="model.image"
        class="card-img-top"
        :alt="model.MODName"
      >
      <div class="card-body d-flex flex-column">
        <h4 class="h3 card-title mb-1">
          <span class="make-name">{{ model.make.name }}</span> {{ model.MODNameGrp1 }} {{ model.body_type }}
        </h4>
        <p class="card-text model-availability model-available mb-0">
          <i class="fas fa-circle fa-1x"></i>
          {{ model.type_count }} változat rendelhető
        </p>
        <div class="mb-4">
          <p
            v-if="model.available_number > 0"
            class="model-availability model-available mt-0"
            @click.prevent="openStock(model.publicUrl)"
          >
            <i class="fas fa-circle fa-1x"></i>
            {{ model.available_number }} darab elérhető
          </p>
          <p
            v-if="model.config && model.config.card_text"
            class="card-text mb-4"
          >
            {{ model.config.card_text }}
          </p>
        </div>
        <button
          type="button"
          class="btn btn-block btn-primary btn-sm mt-auto"
        >
        <template v-if="getCalculatedPrice">
            {{ getCalculatedPrice | currency }} Ft + ÁFÁ-tól
        </template>
          <template v-else>
            Hívjon bennünket!
          </template>
        </button>
      </div>
    </a>
  </div>
</template>

<script>
    import Vue from 'vue';
    import { namespace } from 'vuex-class';
    import { Component, Prop } from 'vue-property-decorator';

    const priceSearchModule = namespace('price_search');

  @Component
  export default class ModelCard extends Vue {

    @priceSearchModule.Getter('getContractLength') contractLength;
    @priceSearchModule.Getter('getAnnualMileage') annualMileage;
    @priceSearchModule.State('filters') filters;
    @priceSearchModule.Getter('getPrinp2') prinp2;
    @priceSearchModule.Getter('getM') getM;
    @priceSearchModule.Getter('getInitialPaymentPercent') initialPaymentPercent;
    @priceSearchModule.Mutation('setModel') setModel;

    @Prop(Object) model;
    @Prop(String) page;


    created() {
      localStorage.setItem('filter', JSON.stringify(this.filters));
    }

    get getCalculatedPrice() {

      if (!this.contractLength || !this.annualMileage) {
        return this.model.price_60_10;
      }

      let model = this.model;

        const priceKey = `price_${this.contractLength}_${this.annualMileage}`;
        const partnerPrice = model[priceKey];

      if (!partnerPrice) {
        return ''
      }

      let mparam = model.m ? model.m : 0.5;

      const price = (partnerPrice * this.contractLength - (this.initialPaymentPercent / 100) * this.prinp2 * mparam) / this.contractLength;

      return price;
    }

    openStock(url) {
      location.href = url + '?stock=1'
    }

    openPublicUrl(url) {

      if (["category", "makes", "flags", "models"].includes(this.page)) {
        this.filters.min_price = 0;
        this.filters.max_price = 0;
      }

      localStorage.setItem('filter',JSON.stringify(this.filters));
      location.href = url;
    }
  }
</script>

<style scoped>
  .model-card:hover {
    text-decoration: none;
  }

  .card-text {
    color: #676868;
  }

  .cursor-pointer{
    cursor: pointer;
  }
</style>

